import { setEstimateConflictError } from 'store/tasks'
import { notifyError, notifySuccess } from 'ui/components/Notify'
import extractResponseError from './extractResponseError'

export async function safeQuery(fetcher, { successMessage, dispatch, userId } = {}) {
  try {
    const response = await fetcher()
    if (
      (!response && response !== '') ||
      response.status < 200 ||
      response.status >= 300
    ) {
      notifyError(extractResponseError(response))
      if (dispatch) {
        dispatch(setEstimateConflictError({
          id: userId,
          message: response.data.message
        }))
      }
    } else {
      if (successMessage) {
        notifySuccess(successMessage)
      }
      if (dispatch) {
        dispatch(setEstimateConflictError(null))
      }
      return response === '' ? true : response
    }
  } catch (e) {
    notifyError(extractResponseError(e.response ?? e))
  }
  return null
}
